export default __webpack_public_path__ + "static/media/powerPoint.5a4415d7.svg";